import { render, staticRenderFns } from "./TheRightController.vue?vue&type=template&id=24dd0386&scoped=true"
import script from "./TheRightController.vue?vue&type=script&lang=js"
export * from "./TheRightController.vue?vue&type=script&lang=js"
import style0 from "./TheRightController.vue?vue&type=style&index=0&id=24dd0386&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24dd0386",
  null
  
)

export default component.exports